export const formatNumber = (value?: number, maximumFractionDigits = 2) => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '--';
  }
  return value.toLocaleString('zh-CN', { maximumFractionDigits });
};

export const OVERVIEW_POLLING_INTERVAL = 60 * 1000;

const normalizeUnit = (unit?: string) => (unit || '').replace(/\s/g, '').toLowerCase();

export const shouldConvertToWan = (unit?: string) => ['m3', 'm³', 'kwh'].includes(normalizeUnit(unit));

export const formatValueWithWan = (value?: number, unit?: string, maximumFractionDigits = 2) => {
  const displayUnit = unit || '-';
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return {
      displayValue: '--',
      displayUnit,
      valueSuffix: '',
      displayText: '--',
    };
  }

  if (value >= 10000 && shouldConvertToWan(unit)) {
    const displayValue = formatNumber(value / 10000, maximumFractionDigits);
    return {
      displayValue,
      displayUnit,
      valueSuffix: '万',
      displayText: `${displayValue}万`,
    };
  }

  const displayValue = formatNumber(value, maximumFractionDigits);
  return {
    displayValue,
    displayUnit,
    valueSuffix: '',
    displayText: displayValue,
  };
};
